import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <p id="cpryt">
        <span>
          <a href="mailto:pravinsm10@gmail.com">
            <i className="fa fa-envelope social"></i>
          </a>
        </span>
        &nbsp;
        <span>
          <a href="https://github.com/pravinsm">
            <i className="fa fa-github social"></i>
          </a>
        </span>
        &nbsp;
        <span>
          <a href="https://www.linkedin.com/in/pravin-s-m-128610165">
            <i className="fa fa-linkedin-square social"></i>
          </a>
        </span>
      </p>
    </div>
  );
};

export default Footer;
